import type { KeyboardEvent } from "react";

// Gives an element with role="button" the keyboard behavior of a native button (Enter and Space activate it). Keys pressed inside nested controls such as inputs or inner buttons are left to those controls.
export const createActivationKeyDownHandler =
  (onActivate: () => void) => (event: KeyboardEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      // Space would otherwise scroll the page, which a native button prevents too.
      event.preventDefault();
      onActivate();
    }
  };
